// Adressfelder (An/Cc): Text ↔ Liste. Namen dürfen Kommas enthalten („Mettler-Berner, Susanne <s@bs.ch>“),
// deshalb wird nur an Kommas/Semikolons außerhalb von Anführungszeichen und spitzen Klammern getrennt.
export type AddressInput = { address: string; name?: string | undefined };

export function parseAddresses(s: string): AddressInput[] {
  const teile: string[] = [];
  let cur = '';
  let inQuote = false;
  let inAngle = false;
  for (const ch of s) {
    if (ch === '"') inQuote = !inQuote;
    else if (ch === '<' && !inQuote) inAngle = true;
    else if (ch === '>' && !inQuote) inAngle = false;
    if ((ch === ',' || ch === ';') && !inQuote && !inAngle) {
      teile.push(cur);
      cur = '';
    } else cur += ch;
  }
  teile.push(cur);
  // Unquotiert „Nachname, Vorname <adresse>“ (so liefern es Outlook und Canary): ein Teil ohne @ gehört
  // zum Namen des nächsten Teils, der eine Adresse hat.
  const zusammen: string[] = [];
  let offen = '';
  for (const t of teile.map((x) => x.trim()).filter(Boolean)) {
    if (!t.includes('@')) {
      offen = offen ? `${offen}, ${t}` : t;
      continue;
    }
    zusammen.push(offen ? `${offen}, ${t}` : t);
    offen = '';
  }
  if (offen) zusammen.push(offen);
  return zusammen
    .map((x) => {
      const m = /^(.*?)\s*<([^>]+)>$/.exec(x);
      if (!m) return { address: x.replace(/^<|>$/g, '') };
      const name = m[1]!.replace(/"/g, '').trim();
      return { address: m[2]!.trim(), ...(name ? { name } : {}) };
    });
}

export function joinAddresses(l: AddressInput[]): string {
  return l
    .map((a) => {
      if (!a.name) return a.address;
      const name = /[,;<>"]/.test(a.name) ? `"${a.name.replace(/"/g, '')}"` : a.name;
      return `${name} <${a.address}>`;
    })
    .join(', ');
}
